import { ReactNode, useEffect, useState } from "react";

import { useKeycloak } from "@react-keycloak/web";

import { Spin } from "antd";

import { Role } from "@app/keycloak/Role";
import { getUserRole } from "@app/keycloak/RoleDomain";
import { ForbiddenPage } from "@app/pages/error/ForbiddenPage.tsx";
import { setJwt } from "@app/services/api/api.ts";

interface KeycloakAuthenticatorProps {
  children: ReactNode;
}

export const KeycloakAuthenticator = ({
  children,
}: KeycloakAuthenticatorProps) => {
  const { keycloak, initialized } = useKeycloak();
  const [userRoles, setUserRoles] = useState<string[]>([]);
  const [roleInitialized, setRoleInitialized] = useState<boolean>(false);

  keycloak.onTokenExpired = () => {
    keycloak
      .updateToken(1)
      .then(() => setJwt(keycloak.token))
      .catch(() => void keycloak.login());
  };

  keycloak.onAuthLogout = () => void keycloak.login();

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      const roles = keycloak?.realmAccess?.roles ?? [];
      setUserRoles(getUserRole(roles));
      setJwt(keycloak.token);
      setRoleInitialized(true);
    }
  }, [
    initialized,
    keycloak.authenticated,
    keycloak?.realmAccess?.roles,
    keycloak.token,
  ]);

  if (!initialized) {
    return <Spin />;
  }

  if (!keycloak.authenticated) {
    void keycloak.login();
    return <Spin />;
  }

  if (!roleInitialized) {
    return <Spin />;
  }

  if (!userRoles.includes(Role.ADMIN)) {
    return <ForbiddenPage />;
  }

  return <>{children}</>;
};
